(() => {
  const dialog = document.getElementById('lm-delivery');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const $ = selector => dialog.querySelector(selector);
  const messages = JSON.parse($('[data-messages]').textContent);
  const form = $('[data-address]');
  const status = $('[data-status]');
  const key = dialog.dataset.key.trim();
  const mapId = dialog.dataset.mapId.trim();
  const root = dialog.dataset.root || '/';
  let map, marker, geocoder, mapsPromise, selected, countryCode, revision = 0, busy = false, geocoding = false, opener;
  const say = name => { status.textContent = messages[name]; };
  const normalCheckout = () => { window.location.assign('/checkout?locale=ar'); };
  const lock = value => { busy = value; $('[data-continue]').disabled = value; };
  function close() { dialog.close(); opener?.focus(); }
  dialog.addEventListener('close', () => { opener?.focus(); });
  $('[data-close]').addEventListener('click', close);
  $('[data-skip]').addEventListener('click', normalCheckout);
  function open(button) {
    opener = button;
    document.querySelector('cart-drawer')?.close?.();
    if (!dialog.open) dialog.showModal();
    if (!key || !mapId) say('unavailable');
    else if (!map) say('ready');
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button[name="checkout"], input[name="checkout"], a[href]');
    if (!target || target.closest('#lm-delivery') || target.disabled) return;
    let isCheckout = target.name === 'checkout';
    if (target.tagName === 'A') {
      const url = new URL(target.href, location.origin);
      isCheckout = url.origin === location.origin && /\/(?:[a-z]{2}\/)?checkout\/?$/.test(url.pathname);
    }
    if (!isCheckout || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(target);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout' || event.target.closest('#lm-delivery')) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(event.submitter);
  }, true);
  function loadMaps() {
    if (mapsPromise) return mapsPromise;
    if (!key || !mapId) return Promise.reject(new Error('not-configured'));
    mapsPromise = new Promise((resolve, reject) => {
      if (window.google?.maps?.importLibrary) { resolve(); return; }
      const script = document.createElement('script');
      const timer = setTimeout(() => reject(new Error('timeout')), 15000);
      window.lamyaMapsReady = () => { clearTimeout(timer); resolve(); delete window.lamyaMapsReady; };
      const params = new URLSearchParams({ key, callback: 'lamyaMapsReady', loading: 'async', v: 'quarterly', language: 'ar', region: 'SA' });
      script.src = `https://maps.googleapis.com/maps/api/js?${params}`;
      script.async = true;
      script.onerror = () => { clearTimeout(timer); reject(new Error('load')); };
      document.head.append(script);
    }).then(async () => {
      const [{ Map }, { AdvancedMarkerElement }, { Geocoder }] = await Promise.all([
        google.maps.importLibrary('maps'), google.maps.importLibrary('marker'), google.maps.importLibrary('geocoding')
      ]);
      $('[data-map]').hidden = false;
      map = new Map($('[data-map]'), { center: { lat: 24.7136, lng: 46.6753 }, zoom: 6, mapId, mapTypeControl: false, streetViewControl: false, fullscreenControl: false, gestureHandling: 'cooperative' });
      marker = new AdvancedMarkerElement({ map, gmpDraggable: true, title: messages.map_label });
      geocoder = new Geocoder();
      map.addListener('click', e => { if (e.latLng) locateAddress({ location: e.latLng }); });
      marker.addListener('dragend', () => { locateAddress({ location: marker.position }); });
      say('ready');
    }).catch(error => { mapsPromise = null; say('unavailable'); throw error; });
    return mapsPromise;
  }
  async function locateAddress(request) {
    const current = ++revision;
    selected = null; geocoding = true; say('looking');
    try {
      const { results } = await geocoder.geocode(request);
      if (current !== revision) return;
      const result = results[0];
      if (!result) { say('no_result'); return; }
      const parts = result.address_components;
      const part = (type, short = false) => { const p = parts.find(c => c.types.includes(type)); return p ? p[short ? 'short_name' : 'long_name'] : ''; };
      const street = [part('street_number'), part('route')].filter(Boolean).join(' ');
      const address = { address1: street, address2: part('sublocality_level_1') || part('neighborhood'), city: part('locality') || part('postal_town') || part('administrative_area_level_2'), province: part('administrative_area_level_1'), zip: part('postal_code'), country: part('country') };
      countryCode = part('country', true);
      Object.entries(address).forEach(([name, value]) => { form.elements[name].value = value; });
      const point = result.geometry.location;
      const chosen = request.location || point;
      const lat = typeof chosen.lat === 'function' ? chosen.lat() : chosen.lat;
      const lng = typeof chosen.lng === 'function' ? chosen.lng() : chosen.lng;
      selected = { lat, lng };
      marker.position = { lat, lng }; map.setCenter({ lat, lng }); map.setZoom(17); say('review');
    } catch { if (current === revision) say('no_result'); }
    finally { if (current === revision) geocoding = false; }
  }
  $('[data-load]').addEventListener('click', () => { say('loading'); loadMaps().catch(() => {}); });
  $('[data-locate]').addEventListener('click', async () => {
    if (!navigator.geolocation) { say('geo_error'); return; }
    const button = $('[data-locate]'); button.disabled = true;
    try {
      await loadMaps(); say('looking');
      const position = await new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, { enableHighAccuracy: true, timeout: 12000, maximumAge: 0 }));
      await locateAddress({ location: { lat: position.coords.latitude, lng: position.coords.longitude } });
    } catch { say(key && mapId ? 'geo_error' : 'unavailable'); }
    finally { button.disabled = !key || !mapId; }
  });
  $('[data-search]').addEventListener('submit', async event => {
    event.preventDefault(); const address = $('[data-query]').value.trim(); if (!address) return;
    try { await loadMaps(); await locateAddress({ address, region: 'SA' }); } catch { say('unavailable'); }
  });
  form.addEventListener('input', event => { revision++; geocoding = false; if (event.target.name !== 'address2') selected = null; if (event.target.name === 'country') countryCode = null; });
  form.addEventListener('submit', async event => {
    event.preventDefault(); if (busy) return;
    if (geocoding) { say('pending'); return; }
    if (!form.reportValidity()) return;
    lock(true); say('opening');
    try {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!cart.items?.length) { say('empty'); lock(false); return; }
      if (cart.items.some(item => item.selling_plan_allocation || item.item_components?.length || item.parent_relationship || Object.keys(item.properties || {}).length)) {
        say('cart_special'); lock(false); return;
      }
      const variants = new Map();
      cart.items.forEach(item => variants.set(item.variant_id, (variants.get(item.variant_id) || 0) + item.quantity));
      const url = new URL('/ar/cart/' + Array.from(variants, ([id, quantity]) => `${id}:${quantity}`).join(','), location.origin);
      for (const name of ['address1', 'address2', 'city', 'province', 'zip', 'country']) {
        const value = name === 'country' && countryCode ? countryCode : form.elements[name].value.trim();
        if (value) url.searchParams.set(`checkout[shipping_address][${name}]`, value);
      }
      if (cart.note) url.searchParams.set('note', cart.note);
      for (const [name, value] of Object.entries(cart.attributes || {})) {
        if (name !== 'Lamya delivery location') url.searchParams.set(`attributes[${name}]`, value);
      }
      if (selected) url.searchParams.set('attributes[Lamya delivery location]', `https://www.google.com/maps?q=${selected.lat.toFixed(6)},${selected.lng.toFixed(6)}`);
      const discounts = [...new Set([...(cart.discount_codes || []).filter(d => d.applicable !== false).map(d => d.code), ...(cart.cart_level_discount_applications || []).filter(d => d.type === 'discount_code').map(d => d.title)])];
      if (discounts.length) url.searchParams.set('discount', discounts.join(','));
      window.location.assign(url.href);
    } catch { say('checkout_error'); lock(false); }
  });
  if (!key || !mapId) {
    $('[data-load]').disabled = true; $('[data-locate]').disabled = true;
    $('[data-query]').disabled = true; $('[data-search] button').disabled = true;
  }
  window.addEventListener('pageshow', () => { lock(false); });
})();
